import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import BuscarViajes from "@/pages/BuscarViajes";
import Encomiendas from "@/pages/Encomiendas";
import Turismo from "@/pages/Turismo";
import Boleterias from "@/pages/Boleterias";
import Contacto from "@/pages/Contacto";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/buscar-viajes" element={<BuscarViajes />} />
                        <Route path="/encomiendas" element={<Encomiendas />} />
                        <Route path="/turismo" element={<Turismo />} />
                        <Route path="/boleterias" element={<Boleterias />} />
                        <Route path="/contacto" element={<Contacto />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
